  
import React, {useMemo, useEffect , useRef, useCallback} from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { initializeCustomerState, defalutCustomerState, GetCustomerList, GetCustomerDetail, DeleteCustomer } from '../modules/customer';
import XLSX from 'xlsx';
import sample from '../doc/sample.xlsx';
import { saveAs } from 'file-saver';
import { createCustomerDoc, getCustomerAllList } from '../api';
import ReactTable from '../table/ReactTable';
import { confirmAlert } from 'react-confirm-alert';
import ConfirmModal from '../common/ConfirmModal';

const MemberList = ({userInfo, history}) => {  
  const columns = useMemo(
    () => [
      {
        Header: '이름',
        accessor: 'title',
        width: 120,
      },
      {
        Header: '생년월일',
        accessor: 'birthday',
        width: 120,
      },
      {
        Header: '성별',
        accessor: 'gender',
        width: 100,
      },
      {
        Header: '휴대번호',
        accessor: 'phone',
        width: 160,
      },
      {
        Header: '주소',
        accessor: 'address',
        width: 220,
      },
      {
        Header: '상세주소',
        accessor: 'address_detail',
        width: 220,
      }
    ],
    []
  )
  const dispatch = useDispatch();
    const inputRef = useRef();
    const { listData, status, nowPage } = useSelector(({ customer }) => {
      const { listData, status, nowPage } = customer;
      return {
        listData,
        status,
        nowPage,
      }
    }, shallowEqual);
    const getList = useCallback(() => {
      dispatch(GetCustomerList());
    },[dispatch])
    useEffect(()=>{
        getList()
        return () => {
          dispatch(initializeCustomerState({ sliceStoreName: 'listData', defaultState: defalutCustomerState.listData }));
        }
    },[getList, dispatch])
    useEffect(() => {
        if (status === "DELETED" || status === "CREATED" || status === "UPDATED") {
          getList();
        } else if (status === "DETAIL") {
          history.push('/member/create');
        }
    }, [getList, status, history])

  const handleFile = (e) => {
    const inputData = e.target.files[0];
    if(!/\.(xlsx)$/i.test(inputData.name)) {
      alert('xlsx 파일만 선택해 주세요.')
      return
    }
    const reader = new FileReader();
    reader.onload = () => {
      const fileData = reader.result;
      const wb = XLSX.read(fileData, {type: 'binary'});
      wb.SheetNames.forEach((sheetName)=> {
        const rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {range: 1, header:1, defval: ''});
        const dataArr = [];
        if (rowObj.length > 0 ){
          let index = 0;
          rowObj.forEach((el, idx) => {
            const dataObj = {};
            if (el[0]) {
              let gender = '';
              let birthday = '';
              if (el[1] !== '') {
                const setArr = el[1].split('-');
                if (setArr.length === 2){
                  const num = setArr[1][0];
                  if ( num === '1' || num === '3'){
                    gender = '남성'
                  } else if (num === '2' || num === '4'){
                    gender = '여성'
                  }
                  if ( num === '1' || num === '2') {
                    birthday = '19' + setArr[0]
                  } else if ( num === '3' || num === '4') {
                    birthday = '20' + setArr[0]
                  }
                }
              }
              dataObj.manager_id = userInfo && userInfo.uid
              dataObj.title = el[0]
              dataObj.gender = gender
              dataObj.birthday = birthday
              dataObj.phone = el[2]
              dataObj.address = el[3]
              dataObj.address_detail = el[4]
              dataObj.insurance = JSON.stringify([{name : el[5] || '', start_date: el[6] || '', status: el[7] || '', payment: el[8] || '0'}])
              dataObj.input_type = 'EXCEL'
              dataArr.push(dataObj);
              index = dataArr.length - 1;
            } else {
              const setData = JSON.parse(dataArr[index].insurance)
              setData.push({name : el[5] || '', start_date: el[6] || '', status: el[7] || '', payment: el[8] || '0'})
              dataArr[index].insurance = JSON.stringify(setData)
            }
          });
          createCustomerDoc(dataArr).then((res)=> {            
            if (res.data && res.data.errorCode && res.data.errorCode === 910202) {
              alert('최대 1000명까지만 업로드 가능합니다.')
            } else {
              getList();
              alert('업로드 완료')
            }
          }).catch((err)=> {
            alert('업로드 실패')
          })
        }
      });
    }
    reader.readAsBinaryString(inputData);
  }

  const setSecurityNumber = (birthday, gender) => {
    if (birthday && gender) {
      const year = Number(birthday.substr(0, 4));
      let num = '0'
      if (year < 2000) {
        if (gender === '남성') {
          num = '1'
        } else if (gender === '여성'){
          num = '2'
        }
      } else {
        if (gender === '남성') {
          num = '3'
        } else if (gender === '여성') {
          num = '4'
        }
      }
      return birthday + '-' + num + '******';
    } else {
      return '';
    }
  }
  const fileDownload = () => {
    getCustomerAllList().then(res=>{
      const {data} = res;
      if (data) {
        const dataArr = [];
        data.forEach((el, idx) => {
          const dataObj = {}
          const insuranceData = JSON.parse(el.insurance)      
          dataObj['고객명'] = el.title
          dataObj['주민번호'] = setSecurityNumber(el.birthday, el.gender)
          dataObj['휴대전화'] = el.phone
          dataObj['주소(번지수까지만)'] = el.address
          dataObj['상세주소(아파트이름, 동, 호수)'] = el.address_detail
          dataObj['상품명'] = insuranceData[0] ? insuranceData[0].name : ''
          dataObj['가입일'] = insuranceData[0] ? insuranceData[0].start_date : ''
          dataObj['상태'] = insuranceData[0] ? insuranceData[0].status : ''
          dataObj['금액'] = insuranceData[0] ? insuranceData[0].payment : ''
          dataArr.push(dataObj);
          insuranceData.forEach((el2, idx2) => {
            if (idx2 !== 0){
              const insuranceObj = {}
              insuranceObj['상품명'] = el2.name
              insuranceObj['가입일'] = el2.start_date
              insuranceObj['상태'] = el2.status
              insuranceObj['금액'] = el2.payment
              dataArr.push(insuranceObj);
            }
          });
        })
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(dataArr);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelData = new Blob([excelBuffer], {type: fileType});
        saveAs(excelData, `data${fileExtension}`);
      }
    })
  }
  const handleSample = () => {
    saveAs(sample, "sample.xlsx");
  }
  const handleSelected = (selectedIdx) => {
    if (Object.keys(selectedIdx).length > 0) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <ConfirmModal
              title="삭제"
              content="삭제 하시겠습니까?"
              onClose={onClose}
              isCancel={true}
              onConfirm={()=>{
                const selectedData = Object.keys(selectedIdx);
                if (selectedData.length > 0) {
                    const ArrData = selectedData.map(x => listData[x].id)
                    dispatch(DeleteCustomer({IDs: ArrData}));
                }
                onClose();
              }}
            />
          )
        }
      });
    }
  }
  const searchBar = (setValue, selectedIDs) => {
    return (
      <div className="searchBox">
        <div className="left">
          <input
            className="searchInput"
            onChange={(e) => setValue(e.target.value)}
            placeholder="이름, 생년월일, 전화번호 검색"
          ></input>
        </div>
        <div className="right">
          <button className="defaultBtn" style={{marginRight:5}} onClick={() => history.push('/member/create')}>등록</button>         
          <button className="defaultBtn" onClick={() => handleSelected(selectedIDs)} >삭제</button>
        </div>
      </div>
    )
  }
  const onRowClick = (row) => {
    const {id} = row.original
    dispatch(GetCustomerDetail({id: id}));
  }
  return (
    <div className="rollingContent">
      <div className="contentImage08">
        <div className="downloadText">
          <img src={require('../images/donwload-text.png')} alt="donwload"/>
        </div>
        <div className="btnGroup">
          <img  onClick={handleSample} src={require('../images/downloadBtn01.png')} alt="downloadBtn01" />
          <img  onClick={()=>inputRef.current.click()} src={require('../images/downloadBtn02.png')} alt="downloadBtn02" />
          <img  onClick={fileDownload} src={require('../images/downloadBtn03.png')} alt="downloadBtn03" />
          <input type="file" id="upload-file" style={{display: 'none'}} ref={inputRef} onChange={handleFile}/>
        </div>
        <div className="dataList">
          <ReactTable
            nowPage={nowPage}
            columns={columns}
            data={listData}
            searchBar = {searchBar}
            globalFilterCoulmns = {'memberList'}
            onRowClick={onRowClick}
            loading={status === "PENDING"}
            onPageChange={(page)=>{
              dispatch(initializeCustomerState({ sliceStoreName: 'nowPage', defaultState: page }));
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default MemberList;
